import {
    ADD_AUDIO_IN_GROUP,
    ADD_GROUP,
    IAddAudioInGroup,
    IAddGroup,
    IMoveAudioToGroup,
    IRefreshCallGroupAction,
    IRemoveAudioFromGroup,
    IRemoveGroup,
    IResetModelsAction,
    ISetActiveGroupId,
    ISetGroups,
    ISetGroupsLoadedAction,
    ISetLangsAction,
    ISetLanguages,
    ISetUserRolesAction,
    IUpdateAudioAction,
    MOVE_AUDIO_TO_GROUP,
    REFRESH_CALL_GROUP,
    REMOVE_AUDIO_FROM_GROUP,
    REMOVE_GROUP,
    RESET_MODELS_ACTION,
    SET_ACTIVE_GROUP,
    SET_GROUPS,
    SET_GROUPS_LOADED,
    SET_LANGS_ACTION,
    SET_LANGUAGES,
    SET_USER_ROLES_ACTION,
    TAudio,
    TLanguage,
    TUserGroup,
    TUserLanguage,
    TUserRole,
    UPDATE_AUDIO,
} from './types';

export const setUserAvailableGroups = (
    groups: TUserGroup[]
): ISetGroups => ({
    type: SET_GROUPS,
    groups
});

export const setUserGroupsLoadedAction = (
  groupsLoaded: boolean
): ISetGroupsLoadedAction => ({
    type: SET_GROUPS_LOADED,
    groupsLoaded
});

export const setUserLanguages = (
    languages: TUserLanguage[]
): ISetLanguages => ({
    type: SET_LANGUAGES,
    languages
});

export const setActiveGroupId = (
    activeGroupId: number
): ISetActiveGroupId => ({
    type: SET_ACTIVE_GROUP,
    activeGroupId
});

export const addGroup = (
    group: TUserGroup
): IAddGroup => ({
    type: ADD_GROUP,
    group
})

export const refreshCallGroupAction = (
  group: TUserGroup
): IRefreshCallGroupAction => ({
    type: REFRESH_CALL_GROUP,
    group
})

export const removeGroupAction = (
    groupId: number
): IRemoveGroup => ({
    type: REMOVE_GROUP,
    groupId
})

export const addAudioInGroup = (
  audio: TAudio,
  groupId: number
): IAddAudioInGroup => ({
    type: ADD_AUDIO_IN_GROUP,
    groupId,
    audio
})

export const updateAudioAction = (
  audioId: number,
  groupId: number,
  data: Partial<TAudio>,
): IUpdateAudioAction => ({
    type: UPDATE_AUDIO,
    audioId,
    groupId,
    data
})

export const moveAudioToGroupAction = (
  audioId: number,
  fromGroupId: number,
  toGroupId: number
): IMoveAudioToGroup => ({
    type: MOVE_AUDIO_TO_GROUP,
    audioId,
    fromGroupId,
    toGroupId
})

export const removeAudioFromGroupAction = (
  audioId: number,
  groupId: number
): IRemoveAudioFromGroup => ({
    type: REMOVE_AUDIO_FROM_GROUP,
    audioId,
    groupId
})

export const setLangsAction = (
  langs: TLanguage[]
): ISetLangsAction => ({
    type: SET_LANGS_ACTION,
    langs
});

export const setUserRolesAction = (
  userRoles: TUserRole[]
): ISetUserRolesAction => ({
    type: SET_USER_ROLES_ACTION,
    userRoles
});

export const resetModelsAction = (
): IResetModelsAction => ({
    type: RESET_MODELS_ACTION
});
